<template>
  <svg width="32" height="29" viewBox="0 1 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>camera</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.55859 20.1317V8.45044H18.6035V20.1317H5.55859ZM3.55859 7.45044C3.55859 6.89815 4.00631 6.45044 4.55859 6.45044H19.6035C20.1558 6.45044 20.6035 6.89815 20.6035 7.45044V10.4069L23.1732 9.55369C23.8205 9.33878 24.4883 9.8207 24.4883 10.5028V17.8427C24.4883 18.5248 23.8205 19.0067 23.1732 18.7918L20.6035 17.9386V21.1317C20.6035 21.684 20.1558 22.1317 19.6035 22.1317H5.55859H3.55859V20.1317V7.45044ZM20.6367 15.8423V12.5032L22.4883 11.8884V16.457L20.6367 15.8423Z"
    />
  </svg>
</template>
